import { AnimatePresence } from 'framer-motion'
import React from 'react'

import { useManagementGetContacts } from '@apps-common/apis/management/contact'
import { ContactCardSkeleton, ContactListCard } from '@apps-common/apps/portal/pages/management/components/contact'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const ContactInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementGetContacts({
    search: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          {loading && Array.from(Array(20).keys()).map((i) => <ContactCardSkeleton key={`contact-card-skeleton-${i}`} />)}
          {!loading && data?.map((c) => <ContactListCard key={`contact-list-${c.contactId}`} contact={c} />)}
          {!loading && data && data.length > 0 && <NoResultsCard>No contact results.</NoResultsCard>}
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
